import { styled } from '@raskrask-dk/rr-components'

export const StyledBasisTypes = styled('div', {
    display: 'grid',
    position: 'relative',

    '@mobile': {
        gap: 16,
    },

    '@desktop': {
        gap: 40,
        pb: 40,
    },
})
